import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import TextField from "./TextField";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const ComboSelectSimpleTextFiled = ({ options, emptyValue, emptyLabel, SelectProps, multiple, MenuProps, renderValue, ...others }) => (
    <TextField
        {...others}
        select
        SelectProps={{
            multiple,
            MenuProps,
            renderValue,
            ...SelectProps,
        }}>
        {others.value === emptyValue && !isEmpty(emptyValue) &&
            <MenuItem value={emptyValue} disabled>
                <em style={{ color: '#BDBDBD' }}>{emptyLabel ? emptyLabel : "Seleccione..."}</em>
            </MenuItem>
        }
        {options && options.map(record => {
            return (
                <MenuItem key={record.value} value={record.value} disabled={record.disabled || false} style={{ height: 'auto' }}>
                    {record.text}
                </MenuItem>
            )
        })}
    </TextField>
);

ComboSelectSimpleTextFiled.displayName = "ComboSelectSimpleTextFiled";

const ComboSelectWithMoreInfo = ({ moreInfo, key, ...props }) => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }} key={key}>
        <ComboSelectSimpleTextFiled {...props} />
        {moreInfo}
    </div>
)

ComboSelectWithMoreInfo.displayName = "ComboSelectWithMoreInfo";

const defaultProps = {
    margin: 'normal',
    required: false,
    color: 'secondary',
    size: null, //'small',
    fullWidth: true,
    variant: 'outlined',
};

const ComboSelect = (props) => {
    if (props.moreInfo)
        return <ComboSelectWithMoreInfo {...defaultProps} {...props} />
    else
        return <ComboSelectSimpleTextFiled {...defaultProps} {...props} />
}

ComboSelect.propTypes = {
    label: PropTypes.string,
    // id: PropTypes.string.isRequired,
    //field: PropTypes.string.isRequired,
    required: PropTypes.bool,
};

ComboSelect.displayName = "ComboSelect";

export default ComboSelect;